import { useQuery } from '@tanstack/react-query';
import ApiService from '../services/api-service';

import { notification } from 'antd';
import { CustomerInfo } from 'src/types/common.types';

const searchCustomers = async (keyword: string = '') => {
  const response = await ApiService.get<CustomerInfo[]>('/api/customers/search', {
    params: {
      keyword,
    },
  });
  const data = response.data;
  if (response.status !== 200) {
    notification.error({
      message: 'Không thể lấy danh sách khách hàng',
    });
    return [];
  }
  return data;
};

const useCustomers = (keyword: string = '') => {
  return useQuery({
    queryKey: ['customers', keyword],
    queryFn: () => searchCustomers(keyword),
    staleTime: 0,
  });
};

export default useCustomers;
